// extracted by mini-css-extract-plugin
export default {"dropdown":"AdminSettingsDropdown_dropdown__1HO2k","dropdownElement":"AdminSettingsDropdown_dropdownElement__bEGQd"};